import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from './pages/Home/Home';
import NotFound from './pages/NotFound/NotFound';
import PoliticaDePrivacidade from './pages/PoliticaDePrivacidade/PoliticaDePrivacidade';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} /> 
        <Route path="/privacy-policy" element={<PoliticaDePrivacidade />} />
      </Routes>
    </BrowserRouter>
  );
}
